<template>
    <div>
        This is the contact page
    </div>
</template>